import { pipe, chain, without } from 'ramda';
import { createSelector } from 'reselect';
import { uniqueByValue } from '../../utils/uniqueByValue';
import { cardsSelector } from './getCardDataSelector';
import cardMethods from '../../services/transforms/cardMethods';
import { buyingToolsListSelector } from './buyingToolsListSelector';

export const buyingToolsIngredientsSelector = createSelector(
  cardsSelector,
  buyingToolsListSelector,
  (cards, buyingTools) => {
    if (!cards) return [];

    const getIngredients = card =>
      cardMethods[card.containerType]?.getBuyingToolsIngredients?.(card);

    return pipe(
      Object.values,
      chain(getIngredients),
      uniqueByValue,
      without(buyingTools.map(item => item?.[0])),
    )(cards);
  },
);
